import { faPencil } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AgGridReact } from 'ag-grid-react';
import { Button } from 'antd';
import { observer } from 'mobx-react';
import { ServerGridConfig } from '../../../../config/GridConfig';
import Message from '../../../../config/Message';
import { ModuleRegistry, ServerSideRowModelModule } from 'ag-grid-enterprise';
import useStore from '../../../../store';

const ListComponent = observer((props) => {
	ModuleRegistry.registerModules([ServerSideRowModelModule]);
	const { openEditModal } = props;
	const { PUBLICSETTINGS } = useStore();

	const ActionRenderer = (props) => {
		return (
			<div className="action-column">
				<Button
					type="text"
					title={'Edit'}
					className="editIcon"
					onClick={() => {
						PUBLICSETTINGS.readPublicSettings(props.data.id);
						openEditModal();
					}}
				>
					<FontAwesomeIcon color="#1723ad" icon={faPencil} />
				</Button>
			</div>
		);
	};

	const colDefs = [
		{
			headerName: 'Setting Key',
			field: 'settingKey',
			sort: 'asc',
			minWidth: 140,
		},
		{
			headerName: 'Setting Name',
			field: 'settingName',
			minWidth: 140,
		},
		{
			headerName: 'Setting Value',
			field: 'settingValue',
			minWidth: 140,
		},
		{
			headerName: 'Actions',
			field: 'actions',
			cellRenderer: 'ActionRenderer',
			pinned: 'right',
			sortable: false,
			filter: false,
			minWidth: 130,
			width: 130,
		},
	];

	return (
		<div
			className="ag-theme-quartz" // applying the grid theme
			style={{ height: 'calc(100vh - 140px)' }} // the grid will fill the size of the parent container>
		>
			<AgGridReact
				onGridReady={PUBLICSETTINGS.setupGrid}
				headerHeight={35}
				columnDefs={colDefs}
				defaultColDef={ServerGridConfig.defaultColDef}
				columnTypes={ServerGridConfig.columnTypes}
				overlayNoRowsTemplate={Message().noRecord}
				gridOptions={ServerGridConfig.options}
				rowSelection={'multiple'}
				components={{
					ActionRenderer,
				}}
			/>
		</div>
	);
});
export default ListComponent;
